var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentApproved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.993 9.796L11.375 14.2216C11.228 14.3625 11.037 14.4324 10.845 14.4324C10.652 14.4324 10.461 14.3625 10.314 14.2216L8.005 12.0088C7.712 11.728 7.712 11.2728 8.005 10.992C8.298 10.7112 8.772 10.7112 9.065 10.992L10.845 12.6969L14.932 8.77921C15.225 8.49842 15.7 8.49842 15.993 8.77921C16.286 9.06 16.286 9.51521 15.993 9.796ZM12 2.39575C6.762 2.39575 2.5 6.48017 2.5 11.4999C2.5 16.5206 6.762 20.6041 12 20.6041C17.238 20.6041 21.5 16.5206 21.5 11.4999C21.5 6.48017 17.238 2.39575 12 2.39575Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentApproved);
export default __webpack_public_path__ + "static/media/DOCUMENT_APPROVED.ac49686e8dd8bd07057a74bf570e78d3.svg";
export { ForwardRef as ReactComponent };